var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"i4zma","d":"M1260.525 137.2c-.9-.8-1.5-2.1-1.5-3.4 0-1.3.5-2.5 1.4-3.4 1-.8 2.2-1.3 3.5-1.3 1.3 0 2.5.5 3.5 1.4.9.9 1.4 2.1 1.4 3.4 0 1.3-.5 2.5-1.4 3.3-.9.8-2.2 1.4-3.5 1.4-1.3 0-2.5-.5-3.4-1.4zm11.4 3.9l-3.6-3.4c2.1-2.3 1.9-5.8-.3-7.9-1.1-1.3-2.6-1.8-4.1-1.8-1.5 0-3 .5-4.2 1.7-2.3 2.3-2.3 6 0 8.3 1.2 1.2 2.7 1.7 4.2 1.7 1.3 0 2.6-.4 3.7-1.3l3.5 3.4c.2.2.5.2.8 0 .1-.2.1-.6 0-.7z"})),React.createElement("g",{"key":1},React.createElement("g",{"transform":"translate(-1258 -128)"},React.createElement("use",{"fill":"#5e5e5e","xlinkHref":"#i4zma"})))]);
}

SearchInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
